import { API_ROUTES, useApiQuery } from '@shared/api-utils';
import type { LandingPodData } from '../components/OfferPrimary/types';

type UseLandingPodDataParams = {
  landingPageId: string | null;
  enabled?: boolean;
};

/**
 * Hook to fetch landing pod data for a given landing page ID
 *
 * @param landingPageId - The landing page ID (lpid) from URL search params
 * @param enabled - Whether to enable the query (default: true if landingPageId exists)
 * @returns Landing pod data or null if not found/error
 */
function useLandingPodData({ landingPageId, enabled = true }: UseLandingPodDataParams) {
  const landingPodPath = landingPageId ? API_ROUTES.LANDING_PODS.replace(':slug', landingPageId) : '';

  const { data, error, isLoading } = useApiQuery<LandingPodData | null>(landingPodPath, {
    returnNullOn404: true,
    queryOptions: {
      retry: false,
      enabled: enabled && !!landingPodPath,
    },
  });

  return {
    data,
    error,
    isLoading,
  };
}

export { useLandingPodData };
